import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './firebaseConfig'; // Initialize Firebase before App renders
import App from './App';
import { initializeMarketingMeasurement } from './Util/MarketingMeasurement';
//import registerServiceWorker from './registerServiceWorker';

initializeMarketingMeasurement();
ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
